<template>
  <div class="py-5 mb-3">
    <div class="pb-3">
      <div class="source">
        <p>
          <b>Sources 資料來源</b>
        </p>
      </div>
      <div class="pt-3 para">香港醫務委員會</div>
      <div class="pt-1 pb-5 para">The Medical Council of Hong Kong</div>
    </div>
    <div>
      <h2 class="page-title">Policies and measures</h2>
    </div>
    <div class="container">
      <div class="title-container">
        <h5>
          Extracted from the
          <a
            target="_blank"
            href="https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016.pdf"
          >
            <i>"Code of Professional Conduct"</i>
          </a>
        </h5>
        <p>
          Reference:
          <a
            target="_blank"
            href="https://www.elegislation.gov.hk/hk/cap161"
          >Medical Registration Ordinance (Cap. 161)</a>
        </p>
      </div>
      <PolicyEng />
      <div class="py-4"></div>
      <div class="title-container">
        <h5>
          摘錄自
          <a
            target="_blank"
            href="https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016_c.pdf"
          >
            <i>「香港註冊醫生專業守則」</i>
          </a>
        </h5>
        <p>
          參考:
          <a
            target="_blank"
            href="https://www.elegislation.gov.hk/hk/cap161!zh-Hant-HK"
          >《醫生註冊條例》(香港法例第161章)</a>
        </p>
      </div>
      <PolicyChi />

      <div class="pt-5 title-container">
        <h5>更多相關政策或措施的資訊</h5>
        <h5>More Policies or measures related information</h5>
        <div class="py-1"></div>
        <div>
          1.
          <a href="http://tablee.org/" target="_blank">醫訊靈 Tablee</a>
        </div>
        <div>
          2.
          <a
            href="https://soco.org.hk/rightshome/patients-rights/"
            target="_blank"
          >香港社區組織協會-病人權益 Community Legal Information Centre</a>
        </div>
        <div>
          3.
          <a
            href="https://www.clic.org.hk/en/topics/Medical_treatment_consent_and_withdrawal/all.shtml"
            target="_blank"
          >社區法網 Community Legal Information Centre</a>
        </div>
        <div>
          4.
          <a
            href="https://www.hkpv.org/index/research-and-initiative/complaint-mechanism"
            target="_blank"
          >香港病人政策連線 Hong Kong Patients' Voices</a>
        </div>
        <div>
          5.
          <a
            href="http://www.hkapo.org.hk/"
            target="_blank"
          >香港病人組織聯盟 Hong Kong Alliance of Patients' Organization Limited</a>
        </div>
        <div>
          6.
          <a
            href="https://www.rehabsociety.org.hk/zh-hant/"
            target="_blank"
          >香港復康會社區復康網絡 The Hong Kong Society for Rehabiliation</a>
        </div>
        <div>
          7.
          <a
            href="https://www.mingpaocanada.com/tor/htm/News/20150312/HK-gfk1_er_r.htm"
            target="_blank"
          >明報 Ming Pao</a>
        </div>
        <div>
          8.
          <a href="https://eastweek.my-magazine.me/main/56280" target="_blank">東周網 Eastweek</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import PolicyEng from "@/components/PolicyTable_eng.vue";
import PolicyChi from "@/components/PolicyTable_chi.vue";

export default {
  components: {
    PolicyEng,
    PolicyChi
  }
};
</script>

<style scoped>
.about-card {
  margin: auto;
  max-width: 1000px;
  margin-bottom: 100px;
}

.container {
  padding-top: 2rem;
  width: 98%;
}

.title-container {
  text-align: left;
  padding-bottom: 1rem;
}

.title-container a:hover {
  text-decoration: none;
}

.page-title {
  text-align: left;
  padding-left: 6rem;
}

@media only screen and (max-width: 800px) {
  .page-title {
    padding-left: 1.5rem;
  }
}

.source {
  margin-left: 15%;
  margin-right: 15%;
  border-bottom: 1px solid darkslategrey;
}

.para {
  margin-left: 15%;
  margin-right: 15%;
}
</style>